import ColorListPage from "@/pages/ColorListPage";

export default function ActivitiesPage() {
  return (
    <ColorListPage
      title="Activities"
      singular="Activity"
      endpoint="/activities"
      defaultColor="#00b5cc"
      testidPrefix="activity"
    />
  );
}
